// Patch 26 · sends crashes in the visitor's browser to the admin error log (no personal data).
import { API } from "@/lib/api";

const seen = new Set();
const IGNORE = /ResizeObserver loop|Script error\.?$|Non-Error promise rejection|Load failed|NetworkError|Failed to fetch|chrome-extension:|moz-extension:|safari-extension:|AbortError|ChunkLoadError/i;

export function reportError(message, stack) {
  if (!message || IGNORE.test(message) || IGNORE.test(stack || "")) return;
  const key = message + (stack || "").slice(0, 200);
  if (seen.has(key) || seen.size > 20) return;
  seen.add(key);
  try {
    const body = JSON.stringify({ message: String(message).slice(0, 1000), stack: String(stack || "").slice(0, 6000), path: window.location.pathname });
    if (navigator.sendBeacon) navigator.sendBeacon(`${API}/client-errors`, new Blob([body], { type: "application/json" }));
    else fetch(`${API}/client-errors`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true });
  } catch {
    /* never let reporting break the page */
  }
}

export function installErrorReporter() {
  if (typeof window === "undefined" || process.env.NODE_ENV !== "production") return;
  window.addEventListener("error", (e) => reportError(e.message || e.error?.message, e.error?.stack || `${e.filename}:${e.lineno}:${e.colno}`));
  window.addEventListener("unhandledrejection", (e) => {
    const r = e.reason;
    if (r && r.isAxiosError) return; // failed API calls are handled by the page itself
    reportError(r?.message || String(r), r?.stack || "");
  });
}
